import { Component, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { messages } from '../../../../constants/app.messages';
import { PatientEngagementService } from '../../services/patient-engagement.service';

@Component({
  selector: 'app-error-messages',
  templateUrl: './error-messages.component.html',
  styleUrl: './error-messages.component.css',
  encapsulation: ViewEncapsulation.None,
})
export class ErrorMessagesComponent {
  errorMessage!: string | null;
  common_msg!: string | null;
  status!: number;
  error_txt!:boolean;
  elinkData:any;
  PharmacyPhoneNumber:any;
  pharmacyLogo: any;
  pharmacyInfo: any;
  elinkParams: any;
  constructor(private _route: ActivatedRoute, private _patientEngagementService:PatientEngagementService) { }

  ngOnInit(): void {
    console.log("Navigating to error page with status:", this._route.snapshot.paramMap.get('status'));
    this.elinkData = localStorage.getItem("eLinkData")!== 'undefined' ? JSON.parse(localStorage.getItem("eLinkData") || '{}') : {};
    this.elinkParams =  JSON.parse(localStorage.getItem('paramsData') as string);
    this.getPharmacyLogo();
    try { 
        const statusParam = this._route.snapshot.paramMap.get('status');
        if(statusParam === '0'){
          this.errorMessage =  messages.eLink.STATUS_0;
          this.common_msg = messages.eLink.COMMON_MSG;
        } else if(statusParam === '2'){
          this.errorMessage =  messages.eLink.STATUS_2;
          this.common_msg = messages.eLink.COMMON_MSG;
        }    
        this.error_txt = (statusParam === '2') ? true : false;
        this.status = statusParam ? parseInt(statusParam, 10) : 0;
    } catch (error) {
        console.error("Error parsing eLinkData from localStorage:", error);
        this.elinkData = {};
    }
    
  }

  async getPharmacyLogo() {
    const phInfo = {
      "isPreLoginFlow": true,
      "pharmacyNpi": this.elinkParams?.npi,
      "patientId": this.elinkData?.EntityId,
      "isPharmacyLogoRequired": true
    };
    try {
      const resp = await this._patientEngagementService.getPharmacyLogo(phInfo).toPromise();
      if (resp) {
        try {
          const exists = await this._patientEngagementService.checkImageExists(resp.pharmacyLogo);
          if (exists) {
            this.pharmacyLogo = resp.pharmacyLogo;
          }
          this.pharmacyInfo = resp;
        } catch (error) {
          console.error('Error checking image existence:', error);
        }
      }
    } catch (error) {
      console.error('Error posting pharmacy info:', error);
    }
  }
}
